import billingModule from '../../billing.module';

class BillingRequestService {
    constructor($q, billingRequestApiService) {
        this.$q = $q;
        this.billingRequestApiService = billingRequestApiService;
    }

    submitRequest(subscription, plan) {
        if (!subscription || !plan || !plan.id) {
            return this.$q.reject('noSubscriptionOrPlanId');
        }

        return this.billingRequestApiService.submitRequest(
            subscription.id,
            plan.id
        );
    }
}

export default billingModule.service(
    'billingRequestService',
    BillingRequestService
);



// WEBPACK FOOTER //
// ./modules/billing/services/request/billingRequest.service.js